module.exports = __webpack_public_path__ + "static/media/login_logo.dd415425.png";